/**
 *
 * Asynchronously loads the component for Login
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
